// extracted by mini-css-extract-plugin
export default {"wrapper":"cha-z","boldPrefix":"dha-z","link":"eha-z","message":"fha-z","image":"gha-z"};